function InfoPopupContainer(props) {
  return (
    <div className="infoPopup-container" style={{left: props.positionX, width: props.width}}>
      { props.children }
    </div>
  )
}
export default InfoPopupContainer